import AppFormInput from '../../../components/ui/AppFormInput';
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import AnimatedSuccessGIF from '../../../assets/images/check-green.gif';
import apiClient from "../../../services/api-client";
import { useHistory } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { useMountEffect } from 'primereact/hooks';
import PhoneInput from 'react-phone-input-2';
// import '../../../assets/styles/auth-tokens.css';
// import '../../../assets/styles/landing.css';
// import '../../../assets/styles/auth-form.css';

const Signup = () => {
  const [formFields, setFormFields] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [maskedPhoneList] = useState([])
  const [existingFormFields, setExistingFormFields] = useState({
    idNumber: '',
    phoneNumber: '',
    otp: '',
    password: '',
    confirmPassword: '',
    email: ''
  })
  const [registrationSuccess, setRegistrationSuccess] = useState(false)
  const toast = useRef(null);
  const [formErrors, setFormErrors] = useState({});
  const [formStep, setFormStep] = useState(1);
  const [existingCustomer, setExistingCustomer] = useState(false);
  const [userId, setUserId] = useState('')
  const [, setVisible] = useState(false);
  const history = useHistory();

  useMountEffect(() => {
    toggleForms()
  });

  const validateFormStep1 = () => {
    const errors = {};

    if (!formFields.firstName.trim()) {
      errors.firstName = 'First name is required';
    }

    if (!formFields.lastName.trim()) {
      errors.lastName = 'Last name is required';
    }

    // if (!formFields.email.trim()) {
    //   errors.email = 'Email is required';
    // } else if (!/\S+@\S+\.\S+/.test(formFields.email)) {
    //   errors.email = 'Invalid email address';
    // }

    if (!formFields.phoneNumber.trim()) {
      errors.phoneNumber = 'Phone number is required';
    }


    return errors;
  };


  const validateExisiting1 = () => {
    const errors = {};

    // if (existingCustomer && !existingFormFields.idNumber.trim()) {
    //   errors.idNumber = 'ID number is required';
    // }

    if (typeof existingFormFields.idNumber !== 'undefined' && (existingFormFields.idNumber.trim() === '')) {
      errors.idNumber = 'National ID number is required';
    }
    // else if (!/^\d{2}-\d{5,}.*$/.test(existingFormFields.idNumber)) {


    //   errors.idNumber = 'Enter a valid National ID Number (00-1234567A00)';
    // }


    setFormErrors(errors)
    return errors;
  };


  const validateExisiting2 = () => {

    const errors = {}

    if (existingFormFields.phoneNumber.trim().length !== 12) {
      //console.log(existingFormFields.phoneNumber.trim().length)
      errors.phoneNumber = 'Phone number must meet the format (+263 717 787 787)';
    }
    if (selectedPolicy == null) {
      //console.log(selectedPolicy)
      errors.selectedPolicy = 'Select a verification phone number.';
    }

    return errors;

  }


  function toggleForms() {

    if (existingCustomer === false) {
      setExistingCustomer(true)
    }
    else {
      setExistingCustomer(false)

    }
  }

  const validateFormStep2 = () => {
    const errors = {};

    if (!formFields.password.trim()) {
      errors.password = 'Password is required';
    } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(formFields.password)) {
      errors.password =
        'Password must meet the following criteria:\n\n' +
        '- At least 8 characters long\n' +
        '- Contain at least one letter (A-Z or a-z)\n' +
        '- Contain at least one number (0-9)\n' +
        '- Contain at least one special character (@, $, !, %, *, #, ?, or &)\n' +
        'For example, valid passwords include:\n' +
        '- MyP@ssw0rd\n' +
        '- Secur!ty2023\n' +
        '- 1Am$tr0ng#P@ss';
    }

    if (formFields.password !== formFields.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    return errors;
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prevFormFields) => ({
      ...prevFormFields,
      [name]: value,
    }));
  };

  const handleExistingFieldChange = (e) => {
    const { name, value } = e.target;
    setExistingFormFields((prevFormFields) => ({
      ...prevFormFields,
      [name]: value,
    }));

    //console.log(existingFormFields)
  };


  const registerUser = () => {
    setLoading(true);
    const requestData = {
      accessToken: '',
      operation: 'create-user-profile',
      requestBody: {
        firstName: formFields.firstName.toUpperCase(),
        lastName: formFields.lastName.toUpperCase(),
        emailAddress: formFields.email,
        phoneNumber: formFields.phoneNumber,
        isActive: true,
        locked: false,
        enabled: true,
        userType: 'EMPLOYEE',
        userRole: 1,
        credentials: {
          userName: formFields.email,
          password: formFields.password,
        },
      },
    };

    fetch(process.env.REACT_APP_DOVESAPI + 'user/create/customer', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.status === 'SUCCESS') {
          // //console.log(JSON.stringify(data))
          setUserId(data.responseBody.userId)
        } else {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: data.message,
            life: 4000
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Sorry, exception occured, contact admin',
          life: 4000
        });
      });

  };


  const fetchRecordById = async (idNumber) => {
    setLoading(true);


    await apiClient.get('user/requestPhoneNumberVerification/' + idNumber.replace(/[-\s]/g, ''), {

      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((data) => {
        setLoading(false);
        if (data.data.status === 'SUCCESS') {
          data.data.responseBody.forEach(policy => {
            maskedPhoneList.push(
              { name: policy.maskedPhoneNUmber, code: policy.maskedPolicyNumber })
          });

          // setmaskedPhoneList(data.data.responseBody);
          // setMaskedPhone(data.data.responseBody.maskedPhoneNUmber);
          setFormStep(2);

        } else {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: data.data.message,
            life: 4000
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Sorry, exception occured, contact admin',
          life: 4000
        });
      });

  }

  const confirmPhone = async () => {
    setLoading(true);
    //console.log(existingFormFields)
    const requestBody = {
      "accessToken": "",
      "operation": "verifyPhoneNumber",
      "requestBody": {
        "phoneNumber": existingFormFields.phoneNumber,
        "emailAddress": existingFormFields.email,
        "policyNumber":selectedPolicy.code
      }
    };
    await apiClient.post('user/verifyPhoneNumber', requestBody).then((data) => {
      setLoading(false);
      if (
        data.data.status === 'SUCCESS'
      ) {
        setFormStep(3)
        setUserId(data.data.responseBody.userId)
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Check your email and phone, we sent you an OTP',
          life: 4000
        });
      }

      else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: data.data.message,
          life: 4000
        });
      }

    })
      .catch((error) => {
        setLoading(false);
        console.error('Error:', error);
      });
  }


  const handlePhoneNumber = (value) => {

    setExistingFormFields({
      ...existingFormFields,
      phoneNumber: value,
    });

  };

  const setNewUserPassword = async () => {
    setLoading(true);
    const payload = {
      "accessToken": "",
      "operation": "set-new-password",
      "requestBody": {
        "password": existingFormFields.password
      }
    }

    await apiClient.post('user/setNewPassword/' + userId + '/' + existingFormFields.otp, payload).then((data) => {
      setLoading(false);
      if (data.data.status === "SUCCESS") {

        setRegistrationSuccess(true)
        setVisible(true)
      }
      else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: data.data.message,
          life: 4000
        });
      }
    })
      .catch((error) => {
        setLoading(false);
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Sorry, exception occured, contact admin',
          life: 4000
        });
      });
  }
  const handleSubmit = () => {

    let errors = {}

    if (existingCustomer === true) {
      errors = validateExisiting1();

    }
    else {
      errors = validateFormStep1();

    }
    if (formStep === 1) {


      if (Object.keys(errors).length === 0) {
        fetchRecordById(existingFormFields.idNumber);
        setFormErrors({});
      } else {
        setFormErrors(errors);
      }


    } else if (formStep === 2) {

      if (existingCustomer === true) {
        errors = validateExisiting2();
      }
      else {
        errors = validateFormStep2();
      }

      if (Object.keys(errors).length === 0 && existingCustomer === false) {
        registerUser();

      }
      else if (Object.keys(errors).length === 0 && formStep === 2 && existingCustomer === true) {
        confirmPhone();
      }
      else {

        //console.log(errors)
        setFormErrors(errors);
      }
    }

    else if (formStep === 3) {
      setNewUserPassword()
      setFormStep(4)
    }
  };

  const [selectedPolicy, setselectedPolicy] = useState(null);

  const stepCopy = existingCustomer
    ? {
        1: { title: 'Link your policy', subtitle: 'Enter your national ID number to find your policy.' },
        2: { title: 'Verify your details', subtitle: 'Select a phone number and confirm your email to continue.' },
        3: { title: 'Secure your account', subtitle: 'Enter the OTP we sent you and set a password.' },
      }[formStep] || { title: 'Link your policy', subtitle: '' }
    : {
        1: { title: 'Create a new profile', subtitle: 'Are you an existing Doves customer?' },
        2: { title: 'Set a password', subtitle: 'Choose a password to secure your profile.' },
      }[formStep] || { title: 'Create a new profile', subtitle: '' };

  return (
    <>
      <Toast ref={toast} />

      {
        !registrationSuccess ? (
          <>
            <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
              <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="text-center mb-8">
                  <Link to="/landing">
                    <Link to="/" className="flex items-center justify-center space-x-3 mb-6"><img className="h-10 w-auto" src={logo} alt="Doves" /><span className="bg-[#EBF5FF] text-[#135A9C] font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest">Self-Service Portal</span></Link>
                  </Link>
                  
                  <h1 className="text-3xl font-extrabold text-slate-800 mt-4 tracking-tight">{stepCopy.title}</h1>
                  {stepCopy.subtitle && <p className="mt-3 text-sm text-slate-800/70">{stepCopy.subtitle}</p>}
                </div>

                {formStep < 4 ? (
                  <div className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100">
                    {loading ? (
                      <div className="animate-pulse">
                        <div className="flex mb-4 items-center">
                          <div className="w-16 h-16 bg-slate-200 rounded-full mr-4"></div>
                          <div className="flex-1">
                            <div className="h-4 bg-slate-200 rounded w-3/4 mb-2"></div>
                            <div className="h-3 bg-slate-200 rounded w-1/2"></div>
                          </div>
                        </div>
                        <div className="h-32 bg-slate-200 rounded w-full mb-4"></div>
                      </div>
                    ) : <>
                      {existingCustomer === false ? (
                        <>
                          <form name="myform">
                            {formStep === 1 ? (
                              <div className="grid grid-cols-1 gap-4 mt-6">
                                <div className="bg-[#F8FAFC]/50 rounded-2xl p-6 border border-base-200 hover:border-blue-300 hover:shadow-md transition-all flex flex-col">
                                  <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center text-2xl mb-4">
                                    <i className="icofont-id-card"></i>
                                  </div>
                                  <h3 className="text-lg font-bold text-slate-800 mb-2">I already have a Doves policy</h3>
                                  <p className="text-sm text-slate-800/70 mb-6 flex-grow">Link your existing policy to your profile.</p>
                                  <button type="button" onClick={toggleForms} className="btn btn-outline border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-slate-800 hover:border-slate-300 w-full rounded-full font-bold mt-4">
                                    Link Policy <i className="icofont-arrow-right"></i>
                                  </button>
                                </div>
                                <div className="bg-[#F8FAFC]/50 rounded-2xl p-6 border border-base-200 hover:border-blue-300 hover:shadow-md transition-all flex flex-col">
                                  <div className="w-12 h-12 bg-cyan-100 text-cyan-600 rounded-xl flex items-center justify-center text-2xl mb-4">
                                    <i className="icofont-ui-add"></i>
                                  </div>
                                  <h3 className="text-lg font-bold text-slate-800 mb-2">I do not have a Doves policy</h3>
                                  <p className="text-sm text-slate-800/70 mb-6 flex-grow">Create a brand new profile to get started.</p>
                                  <Link to={"/create-new-account"} className="btn btn-outline border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-slate-800 hover:border-slate-300 w-full rounded-full font-bold mt-4">
                                    Create New Profile <i className="icofont-arrow-right"></i>
                                  </Link>
                                </div>
                              </div>
                            ) : (
                              <>
                                <AppFormInput
                                  type="password"
                                  placeholder="Password"
                                  name="password"
                                  value={formFields.password}
                                  onChange={handleFieldChange}
                                  error={formErrors.password}
                                />
                                <AppFormInput
                                  type="password"
                                  placeholder="Confirm Password"
                                  name="confirmPassword"
                                  value={formFields.confirmPassword}
                                  onChange={handleFieldChange}
                                  error={formErrors.confirmPassword}
                                />
                              </>
                            )}
                            {formStep !== 1 && (
                              <button type="button" className="btn w-full rounded-full font-bold mt-6 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none" onClick={handleSubmit}>
                                Sign Up
                              </button>
                            )}
                          </form>
                        </>
                      ) : (
                        <form name="myform1">
                          {formStep === 1 ? (
                            <>
                              <AppFormInput
                                type="text"
                                placeholder="Enter your ID Number"
                                name="idNumber"
                                value={existingFormFields.idNumber}
                                onChange={handleExistingFieldChange}
                                error={formErrors.idNumber}
                              />
                            </>
                          ) : formStep === 2 ? (
                            <>
                              <div className="form-control w-full mb-4">
                                <p className="label-text-alt text-slate-800/60 mt-1">Select one of your phone numbers below and enter to verify</p>
                                <select
                                  required
                                  className="select select-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] text-sm"
                                  value={selectedPolicy?.code ?? ''}
                                  onChange={(e) => {
                                    const option = maskedPhoneList.find((o) => o.code === e.target.value);
                                    setselectedPolicy(option ?? null);
                                  }}
                                >
                                  <option value="" disabled>Select verification phone number</option>
                                  {maskedPhoneList.map((option) => (
                                    <option key={option.code} value={option.code}>{option.name}</option>
                                  ))}
                                </select>
                                {formErrors.selectedPolicy && <p className="text-error text-sm mt-1">{formErrors.selectedPolicy}</p>}
                              </div>

                              <div className="form-control w-full mb-4">
                                <PhoneInput
                                  country={'zw'}
                                  international={false}
                                  value={existingFormFields.phoneNumber}
                                  onChange={(e) => handlePhoneNumber(e)}
                                  placeholder='263 717 787 787'
                                />
                                {formErrors.phoneNumber && <p className="text-error text-sm mt-1">{formErrors.phoneNumber}</p>}
                              </div>
                              <AppFormInput
                                type="text"
                                placeholder="Set Email"
                                name="email"
                                value={existingFormFields.email}
                                onChange={handleExistingFieldChange}
                                error={formErrors.otp}
                              />
                            </>
                          ) : (
                            <>
                              <AppFormInput
                                type="text"
                                inputClassName="text-center tracking-[0.5em] font-mono font-bold"
                                placeholder="OTP"
                                name="otp"
                                value={existingFormFields.otp}
                                onChange={handleExistingFieldChange}
                                error={formErrors.otp}
                              />
                              <AppFormInput
                                type="password"
                                placeholder="Password"
                                name="password"
                                value={existingFormFields.password}
                                onChange={handleExistingFieldChange}
                                error={formErrors.password}
                              />
                              <AppFormInput
                                type="password"
                                placeholder="Confirm Password"
                                name="confirmPassword"
                                value={existingFormFields.confirmPassword}
                                onChange={handleExistingFieldChange}
                                error={formErrors.confirmPassword}
                              />
                            </>

                          )}

                          <button type="button" className="btn w-full rounded-full font-bold mt-6 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none" onClick={handleSubmit}>
                            Next
                          </button>
                        </form>
                      )}
                      <div>
                        {existingCustomer === true && (
                          <p className="mt-6 text-center text-sm text-slate-800/70 font-medium">
                            Do not have a policy ?{' '}
                            <Link to="/create-new-account" className="font-bold text-[#135A9C] hover:underline ml-1">
                              Sign up
                            </Link>
                          </p>
                        )}
                        <p className="mt-6 text-center text-sm text-slate-800/70 font-medium">
                          Already have an account?{' '}
                          <Link className="font-bold text-[#135A9C] hover:underline ml-1" to="/signin">
                            Sign In
                          </Link>
                        </p>
                      </div>
                    </>}
                  </div>

                ) : (
                  <div className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100 flex flex-col items-center text-center">
                    <img className="w-24 h-24 mb-6" src={AnimatedSuccessGIF} alt="" />
                    <h3 className="text-2xl font-extrabold text-slate-800 mb-2">Profile Created Successfully</h3>
                    <p className="text-slate-800/70 mb-6">You can now proceed to login</p>
                    <button
                      onClick={() => {
                        setVisible(false)
                        history.push("/")
                      }}
                      className="btn rounded-full font-bold bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none px-8"
                    >
                      <i className="pi pi-check-circle mr-1" /> Ok
                    </button>
                  </div>
                )}

              </div>
            </div>
          </>
        ) : (

          <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center items-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100 flex flex-col items-center text-center">
              <img className="w-24 h-24 mb-6" src={AnimatedSuccessGIF} alt="" />
              <h3 className="text-2xl font-extrabold text-slate-800 mb-2">Profile Created Successfully</h3>
              <p className="text-slate-800/70 mb-6">You can now proceed to login</p>
              <button
                onClick={() => {
                  setVisible(false)
                  history.push("/signin")
                }}
                className="btn rounded-full font-bold bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none px-8"
              >
                <i className="pi pi-check-circle mr-1" /> Ok
              </button>
            </div>
          </div>

        )}
    </>
  );
};

export default Signup;
